module.exports = __webpack_public_path__ + "img/signupBottom.29701917.svg";